import React from "react";

function UpgadeIcon() {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4477 8.7515C10.2214 8.53291 9.91827 8.41196 9.60364 8.41469C9.289 8.41743 8.98802 8.54363 8.76553 8.76612C8.54305 8.98861 8.41684 9.28959 8.41411 9.60422C8.41137 9.91886 8.53233 10.222 8.75092 10.4483L11.1509 12.8483C11.376 13.0733 11.6811 13.1996 11.9993 13.1996C12.3175 13.1996 12.6227 13.0733 12.8477 12.8483L15.2477 10.4483C15.4663 10.222 15.5873 9.91886 15.5845 9.60422C15.5818 9.28959 15.4556 8.98861 15.2331 8.76612C15.0106 8.54363 14.7096 8.41743 14.395 8.41469C14.0804 8.41196 13.7772 8.53291 13.5509 8.7515L13.1993 9.1031V3.5999C13.1993 3.28164 13.0729 2.97642 12.8478 2.75137C12.6228 2.52633 12.3176 2.3999 11.9993 2.3999C11.6811 2.3999 11.3758 2.52633 11.1508 2.75137C10.9257 2.97642 10.7993 3.28164 10.7993 3.5999V9.1031L10.4477 8.7515Z"
          fill="#111827"
        />
        <path
          d="M3.59961 6.0001C3.59961 5.36358 3.85247 4.75313 4.30255 4.30304C4.75264 3.85295 5.36309 3.6001 5.99961 3.6001H7.19961C7.51787 3.6001 7.82309 3.72653 8.04814 3.95157C8.27318 4.17661 8.39961 4.48184 8.39961 4.8001C8.39961 5.11836 8.27318 5.42358 8.04814 5.64863C7.82309 5.87367 7.51787 6.0001 7.19961 6.0001H5.99961V14.4001H8.39961L9.59961 16.8001H14.3996L15.5996 14.4001H17.9996V6.0001H16.7996C16.4813 6.0001 16.1761 5.87367 15.9511 5.64863C15.726 5.42358 15.5996 5.11836 15.5996 4.8001C15.5996 4.48184 15.726 4.17661 15.9511 3.95157C16.1761 3.72653 16.4813 3.6001 16.7996 3.6001H17.9996C18.6361 3.6001 19.2466 3.85295 19.6967 4.30304C20.1468 4.75313 20.3996 5.36358 20.3996 6.0001V18.0001C20.3996 18.6366 20.1468 19.2471 19.6967 19.6972C19.2466 20.1472 18.6361 20.4001 17.9996 20.4001H5.99961C5.36309 20.4001 4.75264 20.1472 4.30255 19.6972C3.85247 19.2471 3.59961 18.6366 3.59961 18.0001V6.0001Z"
          fill="#111827"
        />
      </svg>
    </span>
  );
}

export default UpgadeIcon;
